import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { CodeListing, Prose } from '@criteria-labs/react-typography';
import { formatCURL } from './formatCURL';
export function RequestFigure({ endpoint }) {
    const curl = formatCURL(endpoint);
    return (_jsx(Prose, { className: "max-w-none", children: _jsx(CodeListing, { code: curl, language: "shell", header: _jsxs("div", { className: "flex items-center px-3 py-2 font-mono text-xs text-white", children: [_jsxs("span", { children: [endpoint.method.toUpperCase(), "\u00A0"] }), _jsx("span", { children: endpoint.path })] }), prominent: true, className: "mt-6" }) }));
}
